import React from "react";


//const baseURL = 'http://localhost/freelancer/web-sch/back/api/';
//const baseURL = 'https://staging.soundcloudhelper.com/back-web-sch/api/';
//const baseURL = 'https://www.soundcloudhelper.com/back-web-sch/api/';




//local, but api on staging
// const Config = {
//   apiURL:'https://staging.soundcloudhelper.com/back-web-sch/api/',
//   tokenExpirationCheckPeriod: 5, //seconds
//   dtBetweenRestAttempts: 4, //seconds
//   maxRestFailsCountInRow:3,
//   appURI:'http://localhost:3000/web-sch/',
//   contactURI:'https://staging.soundcloudhelper.com/contact/'
// }

//staging
// const Config = {
//   apiURL:'https://staging.soundcloudhelper.com/back-web-sch/api/',
//   tokenExpirationCheckPeriod: 5, //seconds
//   dtBetweenRestAttempts: 4, //seconds
//   maxRestFailsCountInRow:3,
//   appURI:'https://staging.soundcloudhelper.com/web-sch/',
//   contactURI:'https://staging.soundcloudhelper.com/contact/'
// }

//on server

// const Config = {
//   baseURL:'https://staging.soundcloudhelper.com/back-web-sch/api/'
// }

//live
// const Config = {
//   apiURL:'https://staging.soundcloudhelper.com/back-web-sch/api/',
//   tokenExpirationCheckPeriod: 5, //seconds
//   dtBetweenRestAttempts: 4, //seconds
//   maxRestFailsCountInRow:3,
//   appURI:'https://staging.soundcloudhelper.com/web-sch/',
//   contactURI:'https://staging.soundcloudhelper.com/contact/'
// }









// //live separated
// const Config = {
//   apiURL:'https://soundcloudhelper.com/back-web-sch/api/',
//   tokenExpirationCheckPeriod: 5, //seconds
//  dtBetweenRestAttempts: 4, //seconds
//   maxRestFailsCountInRow:3,
//   appURI:'https://soundcloudhelper.com/web-sch/',
//   contactURI:'https://soundcloudhelper.com/contact/',
//   dirHostedAt:'/web-sch' //subdir where app is hosted without trailing '/'
//}

//live shadow version: 1.38 version which temporarily run in parallel with live
//const Config = {
//   apiURL:'https://soundcloudhelper.com/back-wsch-v-1-38/api/',
//   tokenExpirationCheckPeriod: 5, //seconds
//   dtBetweenRestAttempts: 4, //seconds
//   maxRestFailsCountInRow:3,
//   appURI:'https://soundcloudhelper.com/web-sch2/',
//   contactURI:'https://soundcloudhelper.com/contact/',
//   dirHostedAt:'/web-sch2' //subdir where app is hosted without trailing '/'
// }

//live version, with the new api in separate folder
const Config = {
  apiURL:'https://soundcloudhelper.com/back-wsch-v-1-38/api/',
  tokenExpirationCheckPeriod: 5, //seconds
  dtBetweenRestAttempts: 4, //seconds
  maxRestFailsCountInRow:3,
  appURI:'https://soundcloudhelper.com/web-sch/',
  contactURI:'https://soundcloudhelper.com/contact/',
  dirHostedAt:'/web-sch' //subdir where app is hosted without trailing '/'
}



//staging separated
/* const Config = {
  apiURL:'https://staging.soundcloudhelper.com/back-stg-sch/api/',
  tokenExpirationCheckPeriod: 5, //seconds
  dtBetweenRestAttempts: 4, //seconds
  maxRestFailsCountInRow:3,
  appURI:'https://staging.soundcloudhelper.com/web-sch/',
  contactURI:'https://staging.soundcloudhelper.com/contact/',
  dirHostedAt:'/web-sch' //subdir where app is hosted without trailing '/'
}
 */
//local
/* const Config = {
  apiURL:'http://soundcloudhelper.test/back-wsch-v-1-38/api/',
  tokenExpirationCheckPeriod: 5, //seconds
  dtBetweenRestAttempts: 4, //seconds
  maxRestFailsCountInRow:3,
  appURI:'https://soundcloudhelper.test/web-sch/',
  contactURI:'https://soundcloudhelper.test/contact/',
  dirHostedAt:'/web-sch' //subdir where app is hosted without trailing '/'
} */

export default Config;
